// 全省征订覆盖率模块
const state = {
  yzd: 0,    // 应征订人数
  sjzd: 0,   // 实际征订人数
  zb: '0%'   // 覆盖率比例
}

const mutations = {
  SET_DATA(state, data) {
    if (data) {
      state.yzd = data.yzd || 0
      state.sjzd = data.sjzd || 0
      state.zb = data.zb || '0%'
    }
  },
  RESET_DATA(state) {
    state.yzd = 0
    state.sjzd = 0
    state.zb = '0%'
  }
}

const getters = {
  data: state => state,
  // 覆盖率百分比（去除%符号的数值）
  coverageRate: state => parseFloat(state.zb) || 0
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
